import React, { FC, PropsWithChildren, useMemo } from 'react'
import styles from '../Filters.module.scss'
import classNames from 'classnames'
import SALink from 'components/SALink'

type SingleButtonParentProps = {
  href?: string
}

type SingleListButton = {
  text: string
  selected: boolean
  onClick?: () => void
  href?: string
}

type SingleListFilterProps = {
  filterOptions: ReadonlyArray<SingleListButton>
  facetName?: string
}

// We use SALink only for SEO
const SingleButtonParent: FC<PropsWithChildren<SingleButtonParentProps>> = ({ href, children }) => {
  if (href) {
    return (
      <SALink href={href} tabIndex={-1}>
        {children}
      </SALink>
    )
  }

  return children
}

const SingleListFilter: FC<SingleListFilterProps> = ({ filterOptions, facetName = '' }) => {
  const hasSelectedValue = useMemo(() => filterOptions.some(({ selected }) => !!selected), [
    filterOptions,
  ])

  const handleClick = (ev, onClick) => {
    ev.preventDefault()
    onClick?.()
  }

  return (
    <div className={styles.listFilterContainer}>
      {filterOptions.map(({ text, selected, onClick, href }) => (
        <SingleButtonParent href={href}>
          <button
            key={text}
            role='radio'
            onClick={(ev) => handleClick(ev, onClick)}
            aria-checked={selected}
            aria-label={`Select ${text}`}
            data-gtm-event='filter'
            data-gtm-info={`${facetName} - ${text}`}
            className={classNames(styles.singleListButton, {
              [styles.singleListButtonSelected]: hasSelectedValue && !selected,
            })}
          >
            {text}
          </button>
        </SingleButtonParent>
      ))}
    </div>
  )
}

export default SingleListFilter
